gsap.registerPlugin(Draggable);

let cardCarousels = document.querySelectorAll(".product-cards-block .slider");
cardCarousels.forEach((carousel) => {
    let parent = carousel.closest(".product-cards-block");
    let numberOfSlides = carousel.querySelectorAll(".slide").length;

    if (numberOfSlides > 1) {
        let width = 0;
        carousel.querySelectorAll(".slide").forEach((slide) => {
            width -= slide.offsetWidth;
            width -= 15;
        });

        width += parent.offsetWidth;

        let draggable = new Draggable(carousel, {
            type: "x",
            bounds: { minX: 0, maxX: width },
            inertia: true,
            throwResistance: 500,
        });
    } else {
        carousel.classList.add("single");
    }
});
